const now = new Date()
const tomorrow = new Date(now)
tomorrow.setDate(tomorrow.getDate() + 1)
const tomorrowEnd = new Date(tomorrow)
tomorrowEnd.setDate(tomorrowEnd.getDate() + 1)
const yesterday = new Date(now)
yesterday.setDate(yesterday.getDate() - 1)

const MOCKUP_EVENTS = [
	{
		id: 1,
		title: "Mockup Long Event",
		allDay: true,
		start: tomorrow,
		end: tomorrowEnd,
	},
	{
		id: 2,
		title: "Mockup All Day Event",
		allDay: true,
		start: yesterday,
		end: yesterday,
	},
	{
		id: 3,
		title: "Mockup All Day 2 Event",
		allDay: true,
		start: yesterday,
		end: yesterday,
	},
	{
		id: 4,
		title: "Mockup All Day 2 Event",
		allDay: true,
		start: yesterday,
		end: yesterday,
	},
]

export default MOCKUP_EVENTS
